/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import Form from 'forms/_.extend';

import ArchiveAccountForm from './ArchiveAccountForm/ArchiveAccountForm';
import ArchiveAccountSuccess from './ArchiveAccountSuccess/ArchiveAccountSuccess';
import ArchiveAccountError from './ArchiveAccountError/ArchiveAccountError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  currentAccountDetails: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class ArchiveAccount extends React.Component<*> {
  createForm = () => {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const currentAccountDetails: Object = this.props.currentAccountDetails;
    const fields: Array<Object> = [
      {
        name: 'archiveAccountForm',
        label: 'Archive Account',
        title: 'Archive Account',
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.reason_for_archiving'),
            rules: 'required|string',
            value: '',
            type: 'select',
            placeholder: 'Select a reason',
            options: [
              {
                id: 1,
                label: t('general:reasons.options.account_no_longer_in_use'),
              },
              {
                id: 'other',
                label: t('general:reasons.options.other'),
              },
            ],
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const {
          reason,
        }: //reason text
        Object = data.values().archiveAccountForm;

        actionDrawerStore.archiveAccount(currentAccountDetails.id, {
          activity_reason: reason,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: 'Archive Account',
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { currentAccountDetails, actionDrawerStore }: TypeProps = this.props;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.archive_trading_account')} />
          <ArchiveAccountError currentAccountDetails={currentAccountDetails} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.archived}`}>
          <ActionDrawerHeader title={t('general:actions.archive_trading_account')} />
          <ArchiveAccountSuccess currentAccountDetails={currentAccountDetails} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.archive_trading_account')} />
        <ArchiveAccountForm
          currentAccountDetails={currentAccountDetails}
          form={this.createForm()}
        />
      </div>
    );
  }
}
